import React from 'react';
import { ListItem, ListItemIcon, ListItemText } from '@material-ui/core';
import CheckCircleOutlineIcon from '@material-ui/icons/CheckCircleOutline';
import RadioButtonUncheckedIcon from '@material-ui/icons/RadioButtonUnchecked';
import './EasterEggListItem.scss';

interface EasterEggListItemProps {
	eggName: string;
	dateFound: string | null;
}

const EasterEggListItem: React.FC<EasterEggListItemProps> = (props: EasterEggListItemProps) => {
	const { eggName, dateFound } = props;

	return (
		<ListItem className='easter-egg__user-list-item' key={eggName}>
			<ListItemIcon className='list-item-icon'>
				{dateFound ? <CheckCircleOutlineIcon className='check-icon' /> : <RadioButtonUncheckedIcon className='uncheck-icon' />}
			</ListItemIcon>
			<ListItemText primary={eggName} secondary={dateFound ? dateFound : <i>Not found</i>} />
		</ListItem>
	);
};

export default EasterEggListItem;
